export const showManagerApproval = (state) => state.VNManagerApproval?.showManagerApproval || false

export const getManagerApprovalOnSuccess = (state) => state.VNManagerApproval?.managerApprovalOnSuccess

export const getManagerApprovalOnFailure = (state) => state.VNManagerApproval?.managerApprovalOnFailure

export const getManagerApprovalButtonText = (state) => state.VNManagerApproval?.managerApprovalButtonText
